import cartCounter from "./cartCounter"
export default cartCounter;
